/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo 
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var List = kendo.ui.List,
        StaticList = kendo.ui.StaticList;
    if (!List || List.updated) return;

    /**
     * Some list adjustment for popups. Didn't apply proper width in FF for our
     * solution.
     * TODO : still some problems; also overflow / items text wrapping should
     * be configurable.
     */
    function listAdjustWidth() {
        var list = this.list;
        if (!list || !list.length) return undefined;
        var width = list[0].style.width;
        if (!list.data("width") && width) return undefined;
        var wrapper = this.wrapper,
            boundingRect = wrapper[0].getBoundingClientRect(),
            computedWidth = typeof boundingRect.width != "undefined" ? parseFloat(boundingRect.width) : wrapper.outerWidth();
        width = computedWidth - (list.outerWidth() - list.width());
        list
            .css({
                fontFamily: wrapper.css("font-family"),
                "min-width": width,
                "box-sizing": "border-box"
            })
            .data("width", width);

        // max-width due to items with too long text
        var w = ($(window).width()) + 'px',
            $listParent = list.parent();
        list.css('max-width', w);
        !$listParent.is('body') && $listParent.css('max-width', w);

        return true;
    }

    /**
     * Fix for first open of dropdown in IE11
     */
    function listFirstOpen() {
        var height = this._height(this.dataSource.flatView().length);
        this._calculateGroupPadding(height);
        this.popup._hovered = true;
    }

    var oldListInit = List.fn.init,
        newListInit = function (element, options) {
            var self = this;
            // call original constructor
            oldListInit.call(self, element, options);
            // make sure list is resized properly
            if (typeof ori != "undefined" && typeof ori.device != "undefined") {
                ori.device.bindResize(function () { self._adjustListWidth(); });
            }
        };

    List.prototype.init = newListInit;
    List.prototype._adjustListWidth = listAdjustWidth;
    List.prototype._firstOpen = listFirstOpen;
    List.updated = true;

    if (!StaticList || StaticList.updated) return;

    /**
     * There is a new div wrapper generated around some types of lists from some Kendo version up,
     * and the original JS counts with this. The wrapper seems to be generated around static list
     * and virtualized lists.
     *
     * We make the wrapper non-scrollable via some hack in styles to not have double styling
     * for list popups ( so far; maybe this will get updated during time when all the usage cases
     * settle down a little bit ... ).
     *
     * So here, if the content is non-scrollable, we have to find its scrollable child and apply the
     * scroll position to it.
     */
    function newStaticListScroll(item) {
        if (!item) return;
        if (item[0]) item = item[0];
        var content = this.content[0];
        // check for scrollability of content
        if (!content) return;
        if (content.scrollHeight === content.offsetHeight) {
            content = $(content).find("ul")[0];
        }
        if (!content) return;
        // do the original positioning stuff
        var itemOffsetTop = item.offsetTop,
            itemOffsetHeight = item.offsetHeight,
            contentScrollTop = content.scrollTop,
            contentOffsetHeight = content.clientHeight,
            bottomDistance = itemOffsetTop + itemOffsetHeight,
            above = contentScrollTop > itemOffsetTop,
            below = bottomDistance > (contentScrollTop + contentOffsetHeight);
        // there are some cases where the item's position & size seems to not be available
        // for now ignoring them ...
        if (!itemOffsetHeight) return;
        if (above) {
            contentScrollTop = itemOffsetTop;
        } else if (below) {
            contentScrollTop = (bottomDistance - contentOffsetHeight);
        }
        this.info(
            "Scrolling top list position to %s ...\n" +
            "\t content : %o\n" +
            "\t itemOffsetTop : %s, itemOffsetHeight : %s, contentScrollTop ( original ) : %s, contentOffsetHeight : %s\n" +
            "\t above viewport : %s, below viewport : %s",
            contentScrollTop, content, itemOffsetTop, itemOffsetHeight, content.scrollTop, contentOffsetHeight,
            above, below
        );
        content.scrollTop = contentScrollTop;
    }

    StaticList.prototype.scroll = newStaticListScroll;
    StaticList.updated = true;

})(window.kendo.jQuery);
